import data from './funnel.data'
import itemStyle from './funnel.itemStyle'
import label from './funnel.label'
import labelLine from './funnel.labelLine'
import emphasis from './funnel.emphasis'
import tooltip from './funnel.tooltip'

export default {
  name: "funnel",
  nickname: "漏斗图",
  desc: "funnel",
  type: "object",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc:
        '系列名称，用于<a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip">tooltip</a>的显示，<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend">legend</a> 的图例筛选，在 <code class="codespan">setOption</code> 更新数据和配置项时用于指定对应的系列。',
    },
    gap: {
      name: "gap",
      nickname: "间距",
      desc: "数据图形间距。",
      value: 0,
      defaultValue: 0,
    },
    data,
    itemStyle,
    label,
    labelLine,
    emphasis,
    left: {
      name: "left",
      nickname: "位置左",
      desc: "漏斗图组件离容器左侧的距离。",
      value: 80,
      defaultValue: 80,
      type: "pureValue",
    },
    top: {
      name: "top",
      nickname: "位置上",
      desc: "漏斗图组件离容器上侧的距离。",
      value: 60,
      defaultValue: 60,
      type: "pureValue",
    },
    bottom: {
      name: "bottom",
      nickname: "位置下",
      desc: "漏斗图组件离容器下侧的距离。",
      value: 60,
      defaultValue: 60,
      type: "pureValue",
    },
    width: {
      name: "width",
      nickname: "宽度",
      desc: "漏斗图组件的宽度。默认自适应。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    min: {
      name: "min",
      nickname: "最小值",
      desc: "指定的数据最小值。",
      value: 0,
      defaultValue: 0,
    },
    max: {
      name: "max",
      nickname: "最大值",
      desc: "指定的数据最大值。",
      value: 100,
      defaultValue: 100,
      type: "pureValue",
    },
    minSize: {
      name: "minSize",
      nickname: "数据最小值",
      desc:
        '数据最小值 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-funnel.min">min</a> 映射的宽度。',
      value: "0%",
      defaultValue: "0%",
      type: "pureValue",
    },
    maxSize: {
      name: "maxSize",
      nickname: "数据最大值",
      desc:
        '数据最大值 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-funnel.max">max</a> 映射的宽度。',
      value: "100%",
      defaultValue: "100%",
      type: "pureValue",
    },
    sort: {
      name: "sort",
      nickname: "排序",
      desc:
        '数据排序， 可以取 <code class="codespan">&#39;ascending&#39;</code>，<code class="codespan">&#39;descending&#39;</code>，<code class="codespan">&#39;none&#39;</code>（表示按 data 顺序），或者一个函数（即 <code class="codespan">Array.prototype.sort(function (a, b) { ... })</code>）。',
      value: "descending",
      defaultValue: "descending",
      type: "pureValue",
    },
    tooltip,
    type: {
      name: "type",
      nickname: "类型",
      desc: "type",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
  },
}
